import AccountCancelDissatisfied from './AccountCancelDissatisfied'

export default AccountCancelDissatisfied
// eslint-disable-next-line import/export
export * from './AccountCancelDissatisfied'
